import { gql } from "@apollo/client";

export const CREATE_ITEM = gql`
	mutation CreateItem($input: CreateItemInput!) {
		createItem(createItemInput: $input) {
			_id
			name
			ref
			count
			brand
			priceCost
			iva
		}
	}
`;
